module.exports = __webpack_public_path__ + "static/media/design-1.99d9a630.jpg";